import type { LucideIcon } from 'lucide-react'
import { Users, UserCog, FileText, Banknote, MessageSquare, Settings } from 'lucide-react'

export interface QuickAction {
  labelKey:
    | 'actions.patients'
    | 'actions.staff'
    | 'actions.documents'
    | 'actions.financials'
    | 'actions.chat'
    | 'actions.settings'
  icon: LucideIcon
  to: string
  colorClass: string
}

export const quickActionConfigs: QuickAction[] = [
  {
    labelKey: 'actions.patients',
    icon: Users,
    to: '/patients',
    colorClass: 'bg-blue-500/10 text-blue-500',
  },
  {
    labelKey: 'actions.staff',
    icon: UserCog,
    to: '/staff',
    colorClass: 'bg-purple-500/10 text-purple-500',
  },
  {
    labelKey: 'actions.documents',
    icon: FileText,
    to: '/documents',
    colorClass: 'bg-orange-500/10 text-orange-500',
  },
  {
    labelKey: 'actions.financials',
    icon: Banknote,
    to: '/financials',
    colorClass: 'bg-green-500/10 text-green-500',
  },
  {
    labelKey: 'actions.chat',
    icon: MessageSquare,
    to: '/chat',
    colorClass: 'bg-indigo-500/10 text-indigo-500',
  },
  {
    labelKey: 'actions.settings',
    icon: Settings,
    to: '/settings',
    colorClass: 'bg-gray-500/10 text-gray-500',
  },
]
